/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.ajaxModule')
  .service('BulbAjaxService', [
    '$log', '$q', 'Restangular',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbAjaxService,
  ]);

/**
 * Encapsulates Bulb's RESTful API, including details of URLs, cookies/formTokens, etc.
 *
 * DO LATER : Allow clients to use Restangular API for REST-compliant calls, leaving this service
 * to handle non-RESTful communication with the Bulb back-end, which would require a renaming
 * of this service.
 */
function BulbAjaxService($log, $q, Restangular) {
  // Configure RestAngular
  const AngularRestangular = Restangular.withConfig((RestangularConfigurer) => {
    RestangularConfigurer.setBaseUrl('/b/angular');
  });

  // Configure BulbUnitRestangular
  const BulbUnitRestangular = Restangular.withConfig((RestangularConfigurer) => {
    RestangularConfigurer.setBaseUrl('/b/unit');
  });

  /**
   * Add a response interceptor to all the Restangular instances.
   * // FUTURE: Should probably be only one publicly available Restangular instance.
   * @param responseInterceptor A function of the following form:
   *     function(data, operation, what, url, response, deferred) {
   *     }
   *   This function must return the restangularized data element.
   * @see https://github.com/mgonto/restangular#addresponseinterceptor
   */
  this.addResponseInterceptor = function addResponseInterceptor(responseInterceptor) {
    Restangular.addResponseInterceptor(responseInterceptor);
    AngularRestangular.addResponseInterceptor(responseInterceptor);
    BulbUnitRestangular.addResponseInterceptor(responseInterceptor);
  };

  this.getCurrentAccount = function getCurrentAccount() {
    return Restangular.all('auth').customGET('current');
  };

  // DO LATER : remove this method and let callers just call it themselves via Restangular
  this.getAuthor = function getAuthor(usernameOrEmail) {
    return Restangular.one('authors', usernameOrEmail).get();
  };

  // DO LATER : remove this method and let callers just call it themselves via Restangular once we clean up the
  // server side by making the normal RESTful version handle id or path.
  /**
   * Fetch the unit based on either the unit id or the unit path.
   * @param idOrPath Unit Id or path to use to fetch the unit.
   * @param published Should the published version be fetched if available?  By default, the draft version is fetched
   *     for the author of a unit.  true requests the published version even for the author.
   * @param sharedLink
   * @returns {Promise} Promise resolved with the returned unit.
   */
  this.getUnit = function getUnit(idOrPath, published, sharedLink) {
    // eslint-disable-next-line no-param-reassign
    published = published || false;
    return AngularRestangular.one('units', idOrPath).get({ published, sharedLink });
  };

  /**
   * Create a page as a child of the input parent id.
   * @param parentId The id of the parent unit.
   * @returns {Promise} A promise that resolves to an ObjectIdAndPathRestReply.
   */
  this.createPage = function createPage(parentId) {
    return BulbUnitRestangular.all(`create/DraftPageUnit/${parentId}`).post();
  };

  this.validateField = function validateField(validationType, value, options) {
    const requestMap = {
      validator: validationType,
      fieldValue: value,
      options,
    };
    return Restangular.all('validate').customGET('', requestMap);
  };
}
